import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import Preloader from '../../../components/common/Preloader/Preloader';
import { close as dispatchClose, open } from '../../../modules/modal/actions';
import { WHO_LOGIN_SUCCESS } from '../../../routes/paths';
import Translation from '../../i18n/Translation';

export class OnlineLogin extends React.Component {
  constructor(props) {
    super(props);

    this.overlayRef = null;
    this.resizeModal = this.resizeModal.bind(this);
    this.showIframe = this.showIframe.bind(this);
    this.state = {
      iFrameVisible: false
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeModal);
    this.resizeModal();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeModal);
  }

  resizeModal() {
    if (!this.overlayRef) {
      return;
    }
    const height = Math.min(window.innerHeight, 850);
    this.overlayRef.setAttribute('style', `height: ${height}px`);
  }

  showIframe() {
    this.setState({ iFrameVisible: true });
    this.resizeModal();
  }

  render() {
    const { close, switchModal, requestSource } = this.props;
    const { iFrameVisible } = this.state;
    const modalClasses = classnames(['modal', 'online-login'],
      { 'modal--zero-padding': iFrameVisible });
    const iframeClasses = classnames('modal__iframe', { 'modal__iframe--hidden': !iFrameVisible });
    const footerClasses = classnames({ 'modal__sticky-footer': iFrameVisible });

    const backUrl = `${window.location.protocol}//${window.location.host}${WHO_LOGIN_SUCCESS}`;
    let loginUrl = `${api_config.online_auth_url}/cas/login?service=${encodeURIComponent(backUrl)}`;
    if (requestSource.toLowerCase() === 'login') {
      loginUrl += '&renew=true';
    }

    return (
      <div className={modalClasses}>
        {iFrameVisible && (
          <div className="online-login__promotion-info">
            <Translation section="linkingAccounts" label="loginPromoBanner" />{' '}
            <a className="online-login__switch-modals" onClick={switchModal}>
              <Translation section="linkingAccounts" label="loginPromoTerms" />
            </a>
          </div>
        )}
        <iframe
          className={iframeClasses}
          src={loginUrl}
          ref={ref => {
            this.overlayRef = ref;
          }}
          onLoad={this.showIframe}
          title="onlineLoginFrame"
        />
        {!iFrameVisible && (
          <div className="modal__paragraph">
            <Preloader>
              <Translation section="linkingAccounts" label="tryingLogin" />
            </Preloader>
          </div>
        )}
        <div className={footerClasses}>
          <Button className="modal__button button--secondary" onClick={close}>
            <Translation section="common" label="close" />
          </Button>
        </div>
      </div>
    );
  }
}

OnlineLogin.propTypes = {
  close: PropTypes.func.isRequired,
  switchModal: PropTypes.func.isRequired,
  requestSource: PropTypes.string.isRequired
};

const mapDispatchToProps = {
  close: dispatchClose,
  switchModal: () => open({ componentName: 'OnlineLoginTerms' })
};

export default connect(null, mapDispatchToProps)(OnlineLogin);
